const SIGN_IN_PATH = '/users/sign_in';

export function signInPath(email?: string): string {
  return email ? `${SIGN_IN_PATH}?email=${encodeURIComponent(email)}` : SIGN_IN_PATH;
}
